import { useCallback } from 'react';
import { MenuItem } from 'components/dropdowns/RMDropdown';

export type IngredientRightClickActions = {
  createIngredient: () => void;
  deleteIngredient: () => void;
  copyIngredient: () => void;
  mergeIngredients: () => void;
  isDeleteDisabled: boolean;
  isCopyDisabled: boolean;
  isMergeDisabled: boolean;
};

export const useIngredientRightClickMenuItems = () => {
  const getIngredientRightClickMenuItems = useCallback(
    (actions: IngredientRightClickActions): MenuItem[] => {
      const {
        createIngredient,
        deleteIngredient,
        copyIngredient,
        mergeIngredients,
        isDeleteDisabled,
        isCopyDisabled,
        isMergeDisabled,
      } = actions;

      return [
        {
          label: 'New Ingredient',
          onClick: createIngredient,
        },
        {
          label: 'Delete',
          onClick: deleteIngredient,
          isDisabled: isDeleteDisabled,
        },
        {
          label: 'Copy',
          onClick: copyIngredient,
          isDisabled: isCopyDisabled,
        },
        {
          label: 'Merge',
          onClick: mergeIngredients,
          isDisabled: isMergeDisabled,
        },
      ];
    },
    [],
  );

  return { getIngredientRightClickMenuItems };
};
